// Where the coach button sits while the app doesn't yet know which coach this
// athlete has (/v2/me not answered, or failing: aithlo-frontend#61). Never
// the v1 chat: a quiet spinner, and "Reconnecting to your coach…" once a read
// has failed (V2Context retries on its own; a tap retries now).
import React from 'react';
import { Loader2 } from 'lucide-react';
import { RECONNECTING } from '../../v2/meReader';

export default function CoachConnecting({ reconnecting = false, onRetry }) {
  return (
    <button type="button" onClick={onRetry} disabled={!reconnecting}
      role="status" aria-live="polite" aria-label={reconnecting ? RECONNECTING : 'Connecting to your coach'}
      className="fixed bottom-20 right-4 z-[9999] flex h-14 items-center gap-2 rounded-full bg-bg-surface px-4 text-sm text-text-secondary shadow-lg md:bottom-6 md:right-6">
      <Loader2 size={18} className="animate-spin text-accent-default" />
      {reconnecting && <span>{RECONNECTING}</span>}
    </button>
  );
}
